export const uploadedQuestionForReview = async (values: any, selectedQuestionIds: any[]) => {
  try {
    console.log(values, 'Values', selectedQuestionIds, 'Question Selected')
    // production
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/question/send-for-review-process`, {
      //development
      // const response = await fetch(`http://localhost:3001/question/send-for-review-process`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...values, selected_question_id: selectedQuestionIds }),
    })

    const data = await response.json()
    if (data && data?.status) {
      return true
    }
    return false
  } catch (err) {
    return false
    console.log(err, 'Error is this')
  }
}

export const getAttemptCount = async (question_id: string) => {
  if (question_id) {
    try {
      console.log(question_id, 'Question id')
      const questionCountResponse: any = await fetch(`${process.env.REACT_APP_BACKEND_URL}/question/analysis/${question_id}?mode=count`)
      // const questionCountResponse: any = await fetch(`http://localhost:3001/question/analysis/${question_id}?mode=count`)
      const questionCountDetails = await questionCountResponse?.json()
      if (questionCountDetails) {
        return questionCountDetails?.count || 0
      }
      return 0
    } catch (err) {
      console.log(err)
      return 0
    }
  }
  return 0
}
